// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HighlightFilledSvg from "@fishx/icons-svg/es/asn/HighlightFilled";
import FishxIcon from '../components/FishxIcon';

var HighlightFilled = function HighlightFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HighlightFilledSvg
  }));
};

HighlightFilled.displayName = 'HighlightFilled';
export default React.forwardRef(HighlightFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HighlightFilled.js
// module id = 2928
// module chunks = 0